import axiosClient from "../axiosClient";
import { CheckNullParams } from "../../utils/CheckNullParams";
const productApi = {
  getProducts: (params) => {
    const url = "product";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getProduct: (id) => {
    const url = "product";
    return axiosClient.get(url + "/" + id);
  },

  createProduct: (payload) => {
    const url = "product";
    // const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  updateProduct: (id, payload) => {
    const url = "product/";
    return axiosClient.patch(url + id, payload);
  },
  deleteProduct: (id) => {
    const url = "product/";
    return axiosClient.delete(url + id);
  },
  deleteProducts: (params) => {
    const url = "product";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default productApi;
